import request from '@/utils/request'
import { Toast  } from 'vant'

function SMessage (txt) {
  Toast (txt)
}

function post (url = '', data) {
  if (url) {
    data.c = url
  }
  data.token = localStorage.getItem('token')
  return new Promise((resolve, reject) => {
    request.post(url, data, {}).then(res => {
      let arr = [2081, 2072, 2079, 2078]
      if (res.data.code === 2045) { // 未登录 登录失效
        if (localStorage.getItem('token')) {
          localStorage.setItem('token', '')
          Toast ({
            message: '登录失效/未登录,请先登录!',
            duration: 2000
          })
        } else{
          Toast ({
            message: '登录失效/未登录,请先登录!',
            duration: 2000
          })
        }
      } else if (res.data.errno === 0 || arr.indexOf(res.data.code) != -1) {
        resolve(res.data)
      } else {
        if (url == 'user/phar_in-buy_status' || url == 'user/public_in-access_permissions') {
          if (res.data.code == 2012) {
            resolve(res.data)
            return;
          }
        }
        SMessage(res.data.message)
      }
    }).catch(err => {
        reject(err)
      })
  })
}

function post2 (url = '', data) {
  if (url) {
    data.c = url
  }
  data.token = localStorage.getItem('token')
  return new Promise((resolve, reject) => {
    request.post(url, data, {}).then(res => {
      if (res.data.code === 2045) { // 未登录 登录失效
        if (localStorage.getItem('token')) {
          localStorage.setItem('token', '')
          Toast ({
            message: '登录失效/未登录,请先登录!',
            duration: 2000
          })
        } else{
          Toast ({
            message: '登录失效/未登录,请先登录!',
            duration: 2000
          })
        }
      } else if (res.data.errno === 0) {
        resolve(res.data)
      } else {
        resolve(res.data)
      }
    })
      .catch(err => {
        reject(err)
      })
  })
}

export default {
  post,
  post2,
  SMessage
}
